import React from "react"
import { graphql } from "gatsby"
import Wrapper from '../components/Wrapper/Wrapper'
import Layout from '../components/Layout/Layout'
import SubMenu from '../components/SubMenu/LoadableSubMenu'

export default function Page({ data, location }) {
	const {
		site: {
			siteMetadata: {
				url,
				description: siteDescription,
				title: siteTitle
			}
		}
	} = data;

	let finalSiteTitle = siteTitle;
	if(data.page.title) {
		if(data.page.uri !== '/') {
			finalSiteTitle = `${siteTitle} | ${data.page.title}`
		}
	}
	if(data.page.seo.seoTitle) {
		finalSiteTitle = data.page.seo.seoTitle
	}
	let seo = {
		siteUrl: url,
		pageUrl: data.page.uri ? data.page.uri : url,
		siteDescription: data.page.seo.seoDescription ? data.page.seo.seoDescription : siteDescription,
		siteTitle: finalSiteTitle,
		image: data.page.seo.seoimage ? data.page.seo.seoimage.localFile.childImageSharp.fixed : false
	}

	return (
		<Wrapper seo={seo} menus={{primary: data.menuPrimary, header: data.menuHeader}} location={location}>
			{
				data.page.layout.subMenu
				? <SubMenu blocks={data.page.layout.block} id={data.page.id} />
				: null
			}
			{
				data.page.layout.block
				? data.page.layout.block.map((block, i) =>
						<Layout
							id={`${data.page.id}_${i}`}
							key={`${data.page.id}_${i}`}
							layout={block.layout}
							styles={{
								padding: block.padding,
								containerWidth: block.containerWidth,
								containerSize: block.containerSize,
								background: block.background
							}}
						/>
					)
				: null
			}
		</Wrapper>
	)
}

export const query = graphql`
	query post($id: String!) {
		site: site {
			siteMetadata {
				description
				title
				url
			}
		}
		menuHeader: wpMenu(locations: {eq: HEADER}) {
    		count
			menuItems {
				nodes {
				id
				parentId
				label
				path
				cssClasses
				}
			}
		}
		menuPrimary: wpMenu(locations: {eq: PRIMARY}) {
			count
			menuItems {
				nodes {
				id
				parentId
				label
				path
				cssClasses
				}
			}
		}
		page: wpPage(id: { eq: $id }) {
			title
			id
			uri
			seo {
				seoTitle:seotitle
				seoDescription:seodescription
				seoimage {
					localFile {
						childImageSharp{
							fixed(width: 1200, height:630, cropFocus:CENTER, quality: 80) {
								width
								height
								src
							}
						}
					}
				}
			}
			layout {
				subMenu
				block {
					background
					containerSize
					containerWidth
					padding {
						bottom
						left
						right
						top
					}
					subMenuName
					title
					layout {
						...Layout
					}
				}
			}
		}
	}
`